// extracted by mini-css-extract-plugin
module.exports = {"container":"noteForm_container__yI5BH","fields":"noteForm_fields__3klED","buttons":"noteForm_buttons__1wS86"};